// extracted by mini-css-extract-plugin
export var active = "NavItem-module--active--6fde6";
export var chevron = "NavItem-module--chevron--e863d";
export var forcedark = "NavItem-module--forcedark--c0a56";
export var forcelight = "NavItem-module--forcelight--f2678";
export var item = "NavItem-module--item--2528d";
export var itemText = "NavItem-module--itemText--8f67a";
export var userIcon = "NavItem-module--userIcon--694d2";